import { render, staticRenderFns } from "./QRTFA.vue?vue&type=template&id=195dfd77&scoped=true"
import script from "./QRTFA.vue?vue&type=script&lang=ts"
export * from "./QRTFA.vue?vue&type=script&lang=ts"
import style0 from "./QRTFA.vue?vue&type=style&index=0&id=195dfd77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dfd77",
  null
  
)

export default component.exports